import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-field kn-flex p-m-2" }
const _hoisted_2 = { class: "kn-material-input-label" }
const _hoisted_3 = {
  key: 0,
  class: "p-mt-4"
}
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-mt-4" }
const _hoisted_7 = { class: "kn-material-input-label" }
const _hoisted_8 = { class: "p-mt-4" }
const _hoisted_9 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("span", null, [
        _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('common.language')), 1),
        _createVNode(_component_Dropdown, {
          class: "kn-material-input",
          modelValue: _ctx.selectedFunction.language,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedFunction.language = $event)),
          options: _ctx.functionsCatalogScriptTabDescriptor.languages,
          optionLabel: "value",
          optionValue: "value",
          disabled: _ctx.readonly
        }, null, 8, ["modelValue", "options", "disabled"])
      ])
    ]),
    (_ctx.selectedFunction.language)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", null, [
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.script')), 1),
            _createVNode(_component_VCodeMirror, {
              ref: "codeMirror",
              class: "p-mt-2",
              value: _ctx.code,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.code = $event)),
              autoHeight: true,
              options: _ctx.options,
              onKeyup: _ctx.onKeyUp
            }, null, 8, ["value", "options", "onKeyup"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedFunction.language && _ctx.selectedFunction.family === 'offline')
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.functionsCatalog.trainModel')), 1),
            _createVNode(_component_VCodeMirror, {
              ref: "codeMirror",
              class: "p-mt-2",
              value: _ctx.trainModelCode,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.trainModelCode = $event)),
              autoHeight: true,
              options: _ctx.options,
              onKeyup: _ctx.onKeyUpTrainModel
            }, null, 8, ["value", "options", "onKeyup"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('managers.functionsCatalog.useModel')), 1),
            _createVNode(_component_VCodeMirror, {
              ref: "codeMirror",
              class: "p-mt-2",
              value: _ctx.useModelCode,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.useModelCode = $event)),
              autoHeight: true,
              options: _ctx.options,
              onKeyup: _ctx.onKeyUpUseModel
            }, null, 8, ["value", "options", "onKeyup"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}